/**
 * What each game says on its start screen, built into the app (2026-11-03,
 * Spencer's call). These used to come from each community's KZ_GameDescriptions
 * sheet, which all held the same English and fell out of date as the games
 * were rebuilt. A sheet row can still win by setting its `override` column to
 * TRUE. Keyed by the game's squished type, like gameScoring.
 */
export const GAME_DESCRIPTIONS = {
  BubblePop: "Bubbles float up with pictures in them. Pop the one that matches the word on the sign.",
  WhackAMole: "Animals pop up out of their holes. Tap the ones that match the word on the sign before they hide.",
  Matching: "Turn over two cards at a time to find the pairs. Match every pair to finish.",
  WordToImage: "Tap a word, then tap its picture. Match them all.",
  Wordless: "Listen to the word, then find its picture. There's nothing to read in this one: use your ears!",
  GoodGuess: "The word could be in more than one picture. Find every one.",
  Counting: "How many are there? Tap each one that matches the word to count it.",
  ItemFall:
    "Pictures fall from the sky. Move the chipmunk to catch the ones that match the word, and stay away from the rest.",
  VerbActivity: "Help the chipmunk cross the river: hop onto the stone with the picture that matches the word.",
  FromMeToYou: "Who does it, and to whom? Tap the person doing it, then the person it's done to.",
  SolveIt: "Make the number at the top. Put number cards and plus or minus signs into the problem.",
  Crocodile: "Is it bigger, smaller, or the same? Drag the crocodile that makes the sentence true into the gap.",
  FillInTheBlank: "Read the sentence and drag the word that fills the blank.",
  History: "Drag each card to where it belongs on the timeline. Its date shows once it's placed.",
  StoryBook: "Read the story page by page. Tap a word to hear it.",
};

const squish = (gameType) => String(gameType ?? "").replaceAll(" ", "").replaceAll("-", "");
const isTrue = (value) => value === true || String(value).toUpperCase() === "TRUE";

/** A game's description: the sheet's if it's marked to override, else the app's. */
export const descriptionFor = (gameType, sheetRows = []) => {
  const name = String(gameType ?? "").replaceAll("-", " ");
  const row = sheetRows.find((d) => d.game === name || squish(d.game) === squish(gameType));
  if (row && isTrue(row.override) && row.description) return row.description;
  return GAME_DESCRIPTIONS[squish(gameType)] ?? row?.description ?? "";
};
